import cx from 'classnames'
import { MdOutlinePersonOff } from 'react-icons/md'

export interface NameTagProps extends React.HTMLAttributes<HTMLDivElement> {
  isAbsent?: boolean
}

export function NameTag ({ children, isAbsent, className, ...rest }: NameTagProps): JSX.Element {
  return (
    <div
      className={cx(
        'flex flex-row items-center justify-start transition-opacity',
        isAbsent && 'text-gray-600 bg-gray-200 rounded px-[5px] py-1 -mx-[5px] -my-1',
        typeof rest.onClick === 'function' && 'opacity-80 hover:opacity-100',
        className
      )}
      {...rest}
    >
      {isAbsent && (
        <MdOutlinePersonOff
          size={18}
          className='mr-[3px] flex-shrink-0'
        />
      )}

      <span className='font-roboto font-normal text-base line-clamp-1 leading-none'>
        {children}
      </span>
    </div>
  )
}
